import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

type ConfirmModalProps = {
  open: boolean;
  title: React.ReactNode;
  message: React.ReactNode;
  confirmText?: React.ReactNode;
  cancelText?: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  disabled?: boolean;
};

export const ConfirmModal = ({
  open,
  title,
  message,
  confirmText = (
    <FormattedMessage
      id="RECRUITER.POSTJOB.SETPREFERENCE.INPUT.APPLICATION.YES"
      defaultMessage="Yes"
    />
  ),
  cancelText = (
    <FormattedMessage
      id="RECRUITER.SCHEDULEWORKORDER.EDIT.BUTTON.CANCEL"
      defaultMessage="Cancel"
    />
  ),
  onConfirm,
  onCancel,
  disabled = false,
}: ConfirmModalProps) => {
  if (!open) return null;
  const intl = useIntl();

  return (
    <div
      className="fixed inset-0 z-50 flex items-start justify-center bg-black/60 px-3"
      role="dialog"
      aria-modal="true"
    >
      <div className="mt-[30vh] w-full max-w-[380px]">
        <div className="rounded-[20px] bg-white shadow-sm shadow-slate-300 overflow-hidden">
          <div className="flex items-start justify-between p-5 border-b border-neutral-200">
            <h2 className="font-bold text-base leading-snug text-gray-900 pr-4">
              {title}
            </h2>
            <button
              type="button"
              className="ml-2 text-2xl leading-none font-semibold text-black/70 hover:text-black disabled:opacity-60"
              onClick={onCancel}
              disabled={disabled}
              aria-label={intl.formatMessage({
                id: "POPUP.CLOSE.BUTTON",
                defaultMessage: "Close",
              })}
            >
              ×
            </button>
          </div>

          <div className="p-5">
            <div className="text-sm leading-relaxed text-gray-700">
              {message}
            </div>
          </div>
          <div className="p-5 border-t border-neutral-200 flex items-center justify-end gap-3">
            <button
              disabled={disabled}
              onClick={onCancel}
              className="px-6 py-2.5 rounded-xl border border-[#ff39b3] text-[#ff39b3] hover:bg-red-50 font-bold text-sm disabled:opacity-60"
            >
              {cancelText}
            </button>
            <button
              disabled={disabled}
              onClick={onConfirm}
              className="px-8 py-2.5 rounded-xl bg-[#ff39b3] text-white hover:bg-navy font-bold text-sm disabled:opacity-60"
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
